import { useNavigate, useParams } from 'react-router-dom'

import {
  NewDocumentDocument,
  NewDocumentMutationVariables,
  TrainingDetailDocumentsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { NewFileModal } from 'modules/trainings/components/Files/NewFileModal'
import { FileSubmissionData } from 'modules/trainings/components/Files/NewFileModal/types'

export default function DocumentNewFileModal() {
  const { id } = useParams()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const [createDocument] = useMutation(NewDocumentDocument, {
    extractorFn: (data) => data.trainingsMutations.createTrainingsTrainingFile,
    awaitRefetchQueries: true,
    refetchQueries: [TrainingDetailDocumentsDocument],
  })

  function navigateBack() {
    navigate(
      navigation.trainings.list.details_revamp.view.documents.fullPath({
        id: String(id),
      })
    )
  }

  return (
    <NewFileModal
      description={i18n.t(
        'trainings.trainings_revamp.training_detail.documents.new_file_modal.description'
      )}
      title={i18n.t('trainings.trainings_revamp.training_detail.documents.new_file_modal.title')}
      onClose={navigateBack}
      onSubmit={async (data: FileSubmissionData) => {
        const variables: NewDocumentMutationVariables = {
          trainingId: String(id),
          authorId: data.authorId,
          title: data.title,
        }
        if (data.type === 'signedId' && data.signedId) {
          variables.signedId = data.signedId
        } else if (data.type === 'file') {
          variables.file = data.file
        } else {
          throw new Error('Either file or signedId must be provided')
        }
        const result = await createDocument({
          variables,
        })
        const handled = handleResult(result, () => {
          app.setFlash({
            type: 'wrong',
            message: i18n.t('trainings.trainings_files_modal.create_error'),
          })
        })
        if (handled.success) {
          navigateBack()
        }
      }}
      resourceType="Trainings::Training"
      resourceId={id}
    />
  )
}
